import { config } from '@tshared/config/config'

import req from './req'

export default {
  fetch: req,
  baseUrl: config.getApiBase(),
}
